const header = {
  homepage: 'https://matejicmilan.com/',
  title: 'MM.',
}

const about = {
  name: 'Milan Matejic',
  role: 'Full-stack Developer',
  focus:
    'Founder of I Dream of Apps and Onboarding Diagnostics Lab. I build mobile apps, Web3 developer tooling, onboarding diagnostics, and reliable product experiences.',
  resume:
    'https://drive.google.com/file/d/17zm4YvJF5-Xf4gV8x1LeE2le1YDTVcl8/view?usp=sharing',
  social: {
    linkedin: 'https://www.linkedin.com/in/matejic83/',
    github: 'https://github.com/Mateja3m',
  },
}

const projects = [
  {
    name: 'Infrastructure for Deterministic Onboarding & Analysis',
    description:
      'LF Decentralized Trust Labs project for layered onboarding validation, failure classification, and actionable remediation in decentralized systems.',
    stack: ['TypeScript', 'Node.js', 'CLI', 'Diagnostics', 'LFDT Labs'],
    sourceCode:
      'https://github.com/LF-Decentralized-Trust-labs/onboard-diagnostics',
    livePreview:
      'https://lf-decentralized-trust-labs.github.io/labs/lfdt/onboarding-diagnostics-lab.html',
    liveLabel: 'Lab page',
    sourceLabel: 'GitHub',
    previewImage: '/images/onboarding-diagnostics-preview.png',
    badge: 'Onboarding Diagnostics Lab',
    role: 'Founder & Initial Committer',
    featured: true,
  },
  {
    name: 'CKB Developer Onboarding Guide',
    description:
      'Structured onboarding documentation for developers building on Nervos CKB, focused on the shortest reproducible path, troubleshooting, and verification.',
    stack: ['Documentation', 'Developer Experience', 'CKB', 'Onboarding'],
    sourceCode: 'https://github.com/Mateja3m/ckb-developer-onboarding-guide',
    sourceLabel: 'GitHub',
    previewImage: '/images/ckb-onboarding-guide-preview.svg',
    badge: 'DX Documentation',
  },
  {
    name: 'Dreamy Time',
    description:
      'Dream journaling app for recording, revisiting, and understanding dreams, built under I Dream of Apps.',
    stack: ['React Native', 'Expo', 'AI', 'I Dream of Apps'],
    livePreview:
      'https://play.google.com/store/apps/details?id=com.anonymous.tumacsnova',
    liveLabel: 'Google Play',
    previewImage: '/images/idoa-dreamy-time.jpg',
    badge: 'IDOA Product',
    role: 'Founder, I Dream of Apps',
  },
  {
    name: 'Astro Life',
    description:
      'Daily horoscope, reflection, and flash-message app designed to guide mood, energy, and daily action plans.',
    stack: ['Mobile App', 'React Native', 'Spirituality', 'IDOA'],
    livePreview:
      'https://play.google.com/store/apps/details?id=com.idreamofapps.astrolife',
    liveLabel: 'Google Play',
    previewImage: '/images/idoa-astro-life.png',
    badge: 'IDOA Product',
    role: 'Founder, I Dream of Apps',
  },
  {
    name: 'Numerology Master',
    description:
      'Numerology app for life path numbers, daily numerology tips, compatibility, and clear personal insights.',
    stack: ['Mobile App', 'React Native', 'Numerology', 'IDOA'],
    livePreview:
      'https://play.google.com/store/apps/details?id=com.idreamofapps.numerologymaster',
    liveLabel: 'Google Play',
    previewImage: '/images/idoa-numerology-master.png',
    badge: 'IDOA Product',
    role: 'Founder, I Dream of Apps',
  },
  {
    name: 'Destiny Coin Toss',
    description:
      'Decision-making web app that separates what the heart wants from what logic recommends.',
    stack: ['Web App', 'JavaScript', 'Decision Tool', 'IDOA'],
    livePreview: 'https://destinycointoss.idreamofapps.com/',
    liveLabel: 'Launch app',
    previewImage: '/images/idoa-destiny-coin-toss.jpg',
    badge: 'IDOA Product',
    role: 'Founder, I Dream of Apps',
  },
  {
    name: 'Today Truly Matters',
    description:
      'Daily spirituality and self-improvement quote app built to help users start the day with focus.',
    stack: ['Mobile App', 'React Native', 'Content App', 'IDOA'],
    livePreview:
      'https://play.google.com/store/apps/details?id=com.todaytrulymatters',
    liveLabel: 'Google Play',
    previewImage: '/images/idoa-today-truly-matters.jpg',
    badge: 'IDOA Product',
    role: 'Founder, I Dream of Apps',
  },
  {
    name: 'Maja-Maki-Taxi',
    description:
      'Commercial website created for a local taxi company, focused on clear service information and fast access.',
    stack: ['JavaScript', 'CSS', 'Bootstrap'],
    livePreview: 'https://maja-maki.com/',
    liveLabel: 'Visit site',
    previewImage: '/images/maja-maki-preview.png',
    badge: 'Client Project',
  },
]

const skills = [
  'JavaScript',
  'TypeScript',
  'Node.js',
  'CLI Tooling',
  'React',
  'Next.js',
  'React Native',
  'Expo',
  'Web3 Tooling',
  'Wallet Connectivity',
  'Cross-chain UX',
  'Onboarding Diagnostics',
  'Failure Classification',
  'Preflight Checks',
  'Transaction Simulation',
  'Validation Systems',
  "HubSpot CMS",
  'SASS',
  'Bootstrap',
  'Storybook',
  'MUI',
  'Git',
  'Postman',
'Supabase',
'Firebase'
]

export { header, about, projects, skills }
